import { userService } from '../services'

const state = {
  users: [],
  user: null
}

const getters = {
  find (state) {
    return state.user
  },
  findAll (state) {
    return state.users
  }
}

const mutations = {
  find (state, user) {
    state.user = user
  },
  getAll (state, users) {
    state.users = users.map(user => {
      return { ...user, roles_sort: user.roles }
    })
  },
  create (state, user) {
    const foundAt = state.users.findIndex(u => u.id === user.id)
    if (foundAt === -1) {
      state.users.push(user)
    }
  },
  updateRole (state, user) {
    const foundAt = state.users.findIndex(u => u.id === user.id)

    if (foundAt > -1) {
      state.users.splice(foundAt, 1, { ...user, roles_sort: user.roles })
    }
  },
  updateUser (state, { id, item }) {
    const foundAt = state.users.findIndex(user => user.id === id)
    if (foundAt > -1) {
      state.users.splice(foundAt, 1, item)
    }
  },
  delete (state, id) {
    const foundAt = state.users.findIndex(user => user.id === id)

    if (foundAt > -1) {
      state.users.splice(foundAt, 1)
    }
  }
}

const actions = {
  find (context, userId) {
    return userService.find(userId)
      .then(response => {
        context.commit('find', response.data)
        return response
      })
      .catch(error => {
        let errorMessage = 'Erreur lors de la récupération de l\'utilisateur'
        if (error.response.data.error.exception[0].message.includes('User does not exist')) {
          errorMessage = 'Utilisateur non trouvé dans le portail ESRI'
        }
        context.dispatch('alert/error', errorMessage, { root: true })
        throw error
      })
  },
  findAll (context) {
    return userService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
      })
  },
  create (context, user) {
    context.dispatch('loader/startLoading', 'user/create', { root: true })
    return userService.create(user)
      .then(response => {
        context.commit('create', response.data)
        context.dispatch('alert/success', 'Création réussie de l\'utilisateur.', { root: true })
        return response.data
      })
      .catch(response => {
        context.dispatch('alert/error', response.response.data.error.exception[0].message, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'user/create', { root: true })
      })
  },
  update (context, { id, user }) {
    context.dispatch('loader/startLoading', 'user/update', { root: true })
    return userService.update(id, user)
      .then(response => {
        context.commit('updateUser', response.data)
        context.dispatch('alert/success', 'Mise à jour réussie de l\'utilisateur.', { root: true })
        return response.data
      })
      .catch(response => {
        context.dispatch('alert/error', response.response.data.error.exception[0].message, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'user/update', { root: true })
      })
  },
  updateRole (context, { userId, role }) {
    return userService.updateRole(userId, role)
      .then(response => {
        context.commit('updateRole', response.data)
      })
  },
  delete (context, id) {
    return userService.remove(id)
      .then(response => {
        context.dispatch('alert/success', 'Suppression réussie de l\'utilisateur.', { root: true })
        context.commit('delete', id)
        return response
      })
      .catch(() => {
        context.dispatch('alert/error', 'Erreur lors de la suppression de l\'utilisateur', { root: true })
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
